<script lang="ts" setup>

  type Props = {
    isGreenFee?: boolean
  }
  const props = defineProps<Props>()
</script>

<template>
  <div
    class="c-product-skeleton-card card"
    :class="{ 'is-green-fee': props.isGreenFee }"
  >
    <div class="content">
      <div class="picture">
        <span class="skeleton" />
      </div>
      <div class="description">
        <p class="text line-1">
          <span class="skeleton" />
        </p>
        <p class="text line-2">
          <span class="skeleton" />
        </p>
        <template v-if="isGreenFee">
          <p class="text line-3">
            <span class="skeleton" />
          </p>
          <p class="text line-4">
            <span class="skeleton" />
          </p>
          <p class="text line-5">
            <span class="skeleton" />
          </p>
        </template>
      </div>
      <div class="price">
        <span class="skeleton" />
      </div>
    </div>
  </div>
</template>

<style scoped>

@keyframes gradient-animation {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: 0 100%;
  }
}

.c-product-skeleton-card {
  position: relative;
  z-index: 0;
  display: flex;
  width: 100%;
  max-width: 100%;
  height: 100%;
  flex-direction: row;
  padding: 0.75em 0 1.25em;

  .content {
    display: flex;
    overflow: hidden;
    flex: 1 1 auto;
    flex-direction: row;

    .picture {
      width: 100%;
      flex: 0 0 auto;
      border-radius: 4px;
      aspect-ratio: 3 / 2;
    }

    .description {
      display: flex;
      overflow: hidden;
      flex: 1 1 auto;
      flex-direction: column;
      padding: 1.5em 0 0 1em;

      .text {
        display: flex;
        flex: 0 0 auto;
        flex-direction: column;
        justify-content: flex-start;
        margin-bottom: 0.5em;

        &.line-1 {
          width: 40%;
          height: 22px;
        }

        &.line-2 {
          width: 75%;
          height: 30px;
        }
      }
    }

    .price {
      display: flex;
      width: 120px;
      height: 40px;
      flex: 0 0 auto;
      align-items: flex-end;
      align-self: flex-end;
      justify-content: flex-end;
      padding: 0 0 0 1em;
    }
  }

  &.is-green-fee {
    .content {
      .description {
        justify-content: space-between;
        padding: 0 0 0 1.5em;

        .text {
          &.line-1 {
            width: 75%;
            height: 32px;
          }

          &.line-2 {
            width: 55%;
            height: 22px;
          }

          &.line-3 {
            width: 40%;
            height: 40px;
          }

          &.line-4 {
            width: 40px;
            height: 24px;
          }

          &.line-5 {
            width: 80%;
            height: 22px;
            margin-bottom: 0;
          }
        }
      }

      .price {
        width: 120px;
        height: 75px;
        align-self: center;
      }
    }
  }

  .skeleton {
    display: flex;
    width: 100%;
    min-width: 100%;
    height: 100%;
    min-height: 20px;
    border-radius: 4px;
    animation: gradient-animation 2s ease infinite;
    background: linear-gradient(
      90deg,
      #ddd,
      #ddd,
      #ddd,
      #e8e8e8,
      #ddd,
      #ddd,
      #ddd
    );
    background-position: 100% 0;
    background-size: 400% 100%;
  }

  @media screen and (width >= 1024px) {
    .content {
      .picture {
        width: 30%;
      }
    }

    &.is-green-fee {
      .content {
        .picture {
          width: 40%;
          aspect-ratio: 4 / 3;
        }
      }
    }
  }
}
</style>
